define('SageDotCom/Components/FunnelbackSearchResults',[
    "jquery",
    "underscore",
    "eventManager",
    "score_bootstrap/Utils/UrlHelper",
    "text!SageDotCom/Components/Templates/Result.html",
    "text!SageDotCom/Components/Templates/Pagination.html",
    "text!SageDotCom/Components/Templates/BestBet.html",
    "SageDotCom/DataLayer/Events/product-card-detail",
    "SageDotCom/Utility/sageMatchHeight"
],
    function ($, _, eventManager, urlHelper, template, paginationTemplate, bestBetTemplate, ProductCardDetailEvent, SageMatchHeight) {
        function FunnelbackSearchResults(scope, searchPaginationStatsLabel, noResultsLabel, noResultsPreLabel, noResultsPostLabel, noSearchLabel, tryLabel, buyLabel, contextLanguage, numberOfResults) {
            var searchTerm = urlHelper.getUrlParameters(window.location, "searchterm");
            var searchFacets = getSearchFacets();
            var searchStartRank = getSearchStartRank();
            var totalMatching;
            var $resultsTemplateDiv = $(".js-funnelback-search-results-template", scope);
            var $noResultsDiv = $(".js-no-results", scope);
            var $hideOnLoadDiv = $(".js-hide-on-load", scope);
            var $column2ResultWrapperDiv = $('.score-column2').has($resultsTemplateDiv);
            var collectionParam = urlHelper.getUrlParameters(window.location, "collection");

            //hide search box icon in the header to avoid duplication
            var showHideTimeout = undefined;
            function showHideSearchBox() {
                if ($(scope).length > 0) {
                    $('header').find('a.search').hide();
                    if ($('header').find('input.search-term-input').is(":hidden"))
                        $('header').find('.js-funnelback-search-button').hide();

                    if (!showHideTimeout) {
                        showHideTimeout = setTimeout(function() {
                                if ($('header').find('input.search-term-input').is(":hidden"))
                                    $('header').find('.js-funnelback-search-button').hide();
                            },
                            1000);
                    }
                }
            }
            var timeoutSR = setTimeout(showHideSearchBox(), 0);
            $(window).on('resize', function () {
                clearTimeout(timeoutSR);
                timeoutSR = setTimeout(showHideSearchBox(), 500);
            });

            // convert underscore to mustache syntax
            _.templateSettings.interpolate = /\{\{(.+?)\}\}/g;

            function getSearchStartRank() {
                var startRank = urlHelper.getUrlParameters(window.location, "searchstartrank");
                return startRank && startRank.length > 0 ? startRank[0] : 1;
            }

            function buildNoResultsMessage(term) {
                var noResultsHtml = "";
                if (term == "") {
                    noResultsHtml += noSearchLabel;
                } else {
                    if (noResultsPostLabel) {
                        noResultsHtml += "<p>" + noResultsPreLabel + " <strong>" + term + "</strong></p>";
                    }
                    else {
                        noResultsHtml += "<p>" + noResultsLabel + " <strong>" + term + "</strong></p>";
                    }
                    noResultsHtml += noResultsPostLabel;
                }
                return noResultsHtml;
            }

            function showResults() {
                $(scope).show();
                $noResultsDiv.hide();

                window.scroll(0, 0);

                // clear the results and show loading indication
                $resultsTemplateDiv.empty();
                $hideOnLoadDiv.show();
                var term = searchTerm && searchTerm.length > 0 ? searchTerm[0] : "";
                if (term !== "") {
                    var maxLengthForSearchBox = 50;
                    term = term.replace(/<\/?[^>]+(>|$)/g, "").substring(0, maxLengthForSearchBox);
                }
                var collection = collectionParam && collectionParam.length > 0 ? collectionParam[0] : "";
                $.ajax({
                    url: "/funnelbackdata",
                    type: "GET",
                    data: {
                        searchTerm: term,
                        searchFacets: searchFacets && searchFacets.length > 0 ? searchFacets[0] : "",
                        searchStartRank: searchStartRank,
                        searchNumRanks: numberOfResults, // sends the number of results to the back end service. Comes from rendering params and defaults to 10
                        contextLanguage: contextLanguage, // pass the context language - needed for settings item
                        paramCollection: collection
                    },
                    dataType: "json",
                    success: function (response) {

                        if (response && response.Facets) {
                            eventManager.trigger("display-funnelback-facets-filter", response);
                        }

                        $(".funnelback-refine-btn").css('display', '');

                        if (response && response.Results && response.Results.length > 0) {
                            // show two columns component instead of one if there is at least one result
                            $column2ResultWrapperDiv.addClass("wide-right");

                            // replace labels in template
                            var currTemplate = template.replace("#Try#", tryLabel);
                            currTemplate = currTemplate.replace("#Buy#", buyLabel);
                            var _template = _.template(currTemplate); // generate an underscore template

                            // build the results markup
                            var html = "";
                            var html = createBestBetMarkup(response);

                            for (var j = 0; j < response.Results.length; j++) {
                                // pluck out the item
                                var item = response.Results[j];

                                // wrap each item in a div with unique class
                                html += "<div class='result'>";
                                html += _template(item);
                                html += "</div>";
                            }

                            $resultsTemplateDiv.html(html);

                            // build the pagination markup
                            if (response.ResultsSummary && response.ResultsSummary.ShowPagination) {
                                totalMatching = response.ResultsSummary.TotalMatching;

                                var currSearchPaginationStatsLabel = searchPaginationStatsLabel.replace("#", response.ResultsSummary.DisplayedRanksRange);
                                currSearchPaginationStatsLabel = currSearchPaginationStatsLabel.replace("##", response.ResultsSummary.TotalMatching);
                                var currPaginationTemplate = paginationTemplate.replace("#ResultStats#", currSearchPaginationStatsLabel);
                                var _paginationTemplate = _.template(currPaginationTemplate);
                                var paginationHtml = _paginationTemplate(response.ResultsSummary);

                                $resultsTemplateDiv.append(paginationHtml);
                            }

                            $hideOnLoadDiv.hide();

                            matchProductComparisonHeights();

                            // when results and pagination are built, send CCF message to let other components know
                            eventManager.trigger("funnelback-results-rendered", scope);
                            eventManager.trigger("add-aria-labels-to-pagination");

                        } else { // if no results, show the message
                            // convert two columns component to one column
                            $column2ResultWrapperDiv.removeClass("wide-right");
                            $(".sage-funnelback-facets-filter").css('display', 'none');
                            $hideOnLoadDiv.hide();
                            $(".funnelback-refine-btn").css('display', 'none');
                            if (searchStartRank == 1) {
                                $noResultsDiv.html(buildNoResultsMessage(term));
                                $noResultsDiv.show();
                                $(".page-wrapper .search-term-input.tt-input").focus();
                            }

                            createCurator(response);
                        }
                    },
                    error: function (xhr) {
                        $(scope).hide(); // hide the component on error
                    }
                });


            }

            function createCurator(response) {
                if (response && response.BestBets && response.BestBets.length > 0) {
                    var html = createBestBetMarkup(response);
                    $resultsTemplateDiv.html(html);
                    $resultsTemplateDiv.insertBefore($noResultsDiv);
                    matchProductComparisonHeights();
                }
            }

            function createBestBetMarkup(response) {
                var _bestBetTemplate = _.template(bestBetTemplate);
                var html = "";

                for (var i = 0; i < response.BestBets.length; i++) {
                    var bestBetsItem = response.BestBets[i];
                    if (bestBetsItem.HasDescription && bestBetsItem.DescriptionIsValidHtml) {
                        html += "<div class='best-bet no-border pa-0'>";
                        html += bestBetsItem.Description;
                    }
                    else if (bestBetsItem.HasMessage && bestBetsItem.MessageIsValidHtml) {
                        html += "<div class='best-bet no-border pa-0'>";
                        html += bestBetsItem.Message;
                    }
                    else {
                        if (bestBetsItem.HasPrice) {
                            html += "<div class='best-bet price'>";
                        } else {
                            html += "<div class='best-bet no-price'>";
                        }
                        html += _bestBetTemplate(bestBetsItem);
                    }

                    html += "</div>";
                }

                return html;
            }

            function matchProductComparisonHeights() {
                var columns = $(".best-bet .product-comparison .col");
                if (columns.length > 0) {
                    columns.css("height", "");
                    //Only match height if they aren't stacking
                    if (document.body.clientWidth > 1080) {
                        SageMatchHeight.prototype.applyBinding(columns, true);
                    }
                }
            }

            showResults();

            // when user clicks the page in pagination, change query string and refresh the results
            $(document).on("click", ".js-funnelback-search-results-template .pagination ul.pages li", function (event) {
                event.preventDefault();

                urlHelper.setUrlParameters(window.location, "searchstartrank", $(this).data("query-param-value"));

                eventManager.trigger("refresh-funnelback-search-results");
                window.scrollTo(0, 0);
            });

            $(document).on("click", ".search-buy-btn", function () {
                var originalURL = $(this).attr("href");
                var productService = new ProductCardDetailEvent();

                if (originalURL.indexOf("sku=") > -1) {
                    productService.triggerAddToCartTealiumEvent(originalURL, $(this), "Product Card");
                }
            });

            // listen to CCF message to know when to refresh the results
            eventManager.subscribe("refresh-funnelback-search-results", function () {
                searchTerm = urlHelper.getUrlParameters(window.location, "searchterm");
                searchFacets = urlHelper.getUrlParameters(window.location, "searchfacets");
                searchFacets = replaceSpecialCharacters(searchFacets);

                searchStartRank = getSearchStartRank();

                showResults();
            });

            // funnelback click tracking
            $(document).on("click.funnelbackAnalytics", "[data-funnelback-analytics]", function (event) {
                var url = $(event.currentTarget).data("funnelback-analytics");
                if (url) {
                    $.get(url);
                }
            });

            $(window).on("resize",
                function () {
                    matchProductComparisonHeights();
                });

            // getting the facets value from query string
            function getSearchFacets() {
                const regex = new RegExp("<(\"[^\"]*\"|'[^']*'|[^'\">])*>");
                var searchFacets = urlHelper.getUrlParameters(window.location, "searchfacets");

                if (searchFacets && searchFacets.length > 0) {
                    var searchFacet = searchFacets[0];
                    var searchFacetDecoded = decodeURI(searchFacet);
                    if (regex.test(searchFacetDecoded) || searchFacetDecoded.indexOf("=") > -1 || searchFacetDecoded.indexOf("\"") > -1) {
                        urlHelper.setUrlParameters(window.location, "searchfacets", ""); //Detected HTML or markup allowing scripts, clear the query param
                        return "";
                    }
                    return searchFacet;
                } else {
                    return "";
                }
            }
        }

        function replaceSpecialCharacters(searchFacets) {
            // replace symbol '&' with '%26' since funnelback wrongly interpret '&'
            return searchFacets.map(function (searchFacet) {
                return searchFacet.replace(/&/g, "%26");
            });;
        }

        return function initFunnelbackSearchResults(args) {
            return args.IsExperienceEditorEditing === false
                ? new FunnelbackSearchResults(args.scope,
                    args.SearchPaginationStatsLabel,
                    args.NoResultsLabel,
                    args.NoResultsPreLabel,
                    args.NoResultsPostLabel,
                    args.NoSearchLabel,
                    args.TryLabel,
                    args.BuyLabel,
                    args.ContextLanguage,
                    args.NumberOfResults)
                : null;
        };
    });
